// src/context/AuthContext.js

import React, { createContext, useContext, useEffect, useState } from 'react';
import { refreshToken, logoutUser } from '../api/authApi';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('customRoamUser');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const [accessToken, setAccessToken] = useState(() => {
    return localStorage.getItem('customRoamToken') || null;
  });

  const [loading, setLoading] = useState(false);

  const isLoggedIn = !!user && !!accessToken;

  /**
   * Save user and token to state + localStorage
   */
  const handleLogin = (userData, token) => {
    setUser(userData);
    setAccessToken(token);
    localStorage.setItem('customRoamUser', JSON.stringify(userData));
    localStorage.setItem('customRoamToken', token);
  };
  const clearAuthSession = () => {
    setUser(null);
    setAccessToken(null);
  
    localStorage.removeItem('customRoamUser');
    localStorage.removeItem('customRoamToken');
  };
  /**
   * Logout: clear everything
   */
  const handleLogout = async () => {
    try {
      await logoutUser();
    } catch (e) {
      console.error('Logout error:', e);
    }
    clearAuthSession();
  };
  
  /**
   * Try refreshing token on app load
   */
  const tryRefresh = async () => {
    setLoading(true);
    try {
      const data = await refreshToken();
      if (data?.accessToken) {
        setAccessToken(data.accessToken);
        localStorage.setItem('customRoamToken', data.accessToken);
      }
    } catch (e) {
      console.log('No valid refresh token or session expired');
      handleLogout();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!accessToken && user) {
      tryRefresh();
    }
    // eslint-disable-next-line
  }, []);

  const value = {
    user,
    accessToken,
    isLoggedIn,
    loading,
    handleLogin,
    handleLogout,
    clearAuthSession,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
